function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
// background click is just a convenience method, not an actual a11y issue

import React, { Component } from 'react';
import memoizeOne from 'memoize-one';
import { nanoid } from 'nanoid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { vsEdit, vsGear, vsSave, vsCircleSlash, vsTrash, vsDeviceCamera, dhRefresh, dhNewCircleLargeFilled, vsCircleLargeFilled, vsArrowSmallUp } from '@deephaven/icons';
import Log from '@deephaven/log';
import { Button, CardFlip, RadioGroup, Radio, Select } from '@deephaven/components';
import "./FilterSetManager.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var log = Log.module('FilterSetManager');
var NAME_INPUT_PLACEHOLDER = 'Enter name...';
var EMPTY_LIST_PLACEHOLDER = 'No Available Filter Sets';
class FilterSetManager extends Component {
  static animateScreenFlash() {
    var _document$querySelect;
    var overlay = document.createElement('div');
    overlay.classList.add('screen-flash-overlay');
    overlay.addEventListener('animationend', () => {
      // Removing the element removes its event listeners
      overlay.remove();
    });
    (_document$querySelect = document.querySelector('body')) === null || _document$querySelect === void 0 || _document$querySelect.appendChild(overlay);
  }
  constructor(props) {
    super(props);
    _defineProperty(this, "renameInputRef", /*#__PURE__*/React.createRef());
    _defineProperty(this, "dropdownRef", /*#__PURE__*/React.createRef());
    _defineProperty(this, "editDropdownRef", /*#__PURE__*/React.createRef());
    _defineProperty(this, "isRenamingExistingSet", memoizeOne((filterSets, renameSet) => renameSet !== undefined && filterSets.some(_ref => {
      var id = _ref.id;
      return id === renameSet.id;
    })));
    this.handleSettingsCancel = this.handleSettingsCancel.bind(this);
    this.handleSettingsClick = this.handleSettingsClick.bind(this);
    this.handleSettingsSave = this.handleSettingsSave.bind(this);
    this.handleBackgroundClick = this.handleBackgroundClick.bind(this);
    this.handleEditDropdownChange = this.handleEditDropdownChange.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleFilterApply = this.handleFilterApply.bind(this);
    this.handleCaptureNewSet = this.handleCaptureNewSet.bind(this);
    this.handleNameInputChange = this.handleNameInputChange.bind(this);
    this.handleNameInputKeyPress = this.handleNameInputKeyPress.bind(this);
    this.handleRenameConfirm = this.handleRenameConfirm.bind(this);
    this.handleRenameCancel = this.handleRenameCancel.bind(this);
    this.handleRestoreFullStateChange = this.handleRestoreFullStateChange.bind(this);
    this.handleSetDelete = this.handleSetDelete.bind(this);
    this.handleSetEdit = this.handleSetEdit.bind(this);
    this.handleSetUpdate = this.handleSetUpdate.bind(this);
    this.state = {
      editId: undefined,
      renameSet: undefined,
      nameInputValue: '',
      nameInputError: undefined,
      modifiedFilterSets: [],
      restoreFullState: false
    };
  }
  componentDidMount() {
    var isValueShown = this.props.isValueShown;
    if (isValueShown) {
      this.updateSelectedId();
    } else {
      this.initSettingsScreen();
    }
  }
  componentDidUpdate(prevProps, prevState) {
    var _this$props = this.props,
      isValueShown = _this$props.isValueShown,
      filterSets = _this$props.filterSets;
    var modifiedFilterSets = this.state.modifiedFilterSets;
    if (prevProps.isValueShown && !isValueShown) {
      this.initSettingsScreen();
    }
    if (this.isNameInputScreen() && !this.isNameInputScreen(prevState)) {
      this.focusRenameInput();
    }
    if (filterSets !== prevProps.filterSets) {
      if (!isValueShown && filterSets.length > 0 && prevProps.filterSets.length === 0 && modifiedFilterSets.length === 0) {
        // Filter set added from another panel, flip from the settings side/initial screen to the value side
        var onChange = this.props.onChange;
        onChange({
          isValueShown: true,
          selectedId: filterSets[0].id
        });
      } else {
        this.updateSelectedId();
      }
    }
  }
  initSettingsScreen() {
    var _this$props2 = this.props,
      filterSets = _this$props2.filterSets,
      selectedId = _this$props2.selectedId;
    log.debug('initSettingsScreen', filterSets, selectedId);
    this.setState({
      modifiedFilterSets: [...filterSets],
      editId: selectedId
    });
  }

  // Update selected id without applying the new set on filterSets change
  updateSelectedId() {
    var _this$props3 = this.props,
      isValueShown = _this$props3.isValueShown,
      filterSets = _this$props3.filterSets,
      selectedId = _this$props3.selectedId,
      onChange = _this$props3.onChange;
    log.debug('updateSelectedId', filterSets, selectedId);
    if (!isValueShown) {
      return;
    }
    if (!filterSets.some(_ref2 => {
      var id = _ref2.id;
      return id === selectedId;
    })) {
      // Update the selection if selectedId doesn't exist in the list
      // Flip to the settings side for empty list to show the initial screen
      var isEmptyList = filterSets.length === 0;
      onChange({
        isValueShown: !isEmptyList,
        selectedId: isEmptyList ? undefined : filterSets[0].id
      });
    }
  }
  handleEditDropdownChange(eventTargetValue) {
    this.setState({
      editId: eventTargetValue
    });
  }
  handleFilterChange(eventTargetValue) {
    var selectedId = eventTargetValue;
    var _this$props4 = this.props,
      isValueShown = _this$props4.isValueShown,
      onChange = _this$props4.onChange;
    this.applyFilterSet(selectedId);
    onChange({
      isValueShown,
      selectedId
    });
  }
  handleFilterApply() {
    var selectedId = this.props.selectedId;
    this.applyFilterSet(selectedId);
  }
  handleSettingsCancel() {
    var _this$props5 = this.props,
      onChange = _this$props5.onChange,
      selectedId = _this$props5.selectedId,
      filterSets = _this$props5.filterSets;
    this.setState({
      modifiedFilterSets: []
    });
    // Flip the card to the filter set selection screen if the sets list isn't empty
    // Otherwise show the initial screen
    if (filterSets.length > 0) {
      onChange({
        isValueShown: true,
        selectedId
      });
    }
  }
  handleSettingsSave() {
    var _this$props6 = this.props,
      onChange = _this$props6.onChange,
      onUpdateSets = _this$props6.onUpdateSets;
    var _this$state = this.state,
      modifiedFilterSets = _this$state.modifiedFilterSets,
      editId = _this$state.editId;
    this.setState({
      modifiedFilterSets: []
    });
    log.debug('Update sets', modifiedFilterSets, editId);
    onUpdateSets(modifiedFilterSets);
    // Don't flip the card to the filter set selection screen if the updated sets list is empty
    if (modifiedFilterSets.length > 0) {
      onChange({
        isValueShown: true,
        selectedId: editId
      });
    }
  }
  handleCaptureNewSet() {
    var getFilterState = this.props.getFilterState;
    FilterSetManager.animateScreenFlash();
    var id = nanoid();
    var panels = getFilterState();
    var renameSet = {
      id,
      title: '',
      panels
    };
    log.debug('handleSetCreate', renameSet);
    this.setState({
      nameInputValue: '',
      nameInputError: undefined,
      renameSet
    });
  }
  handleRenameCancel() {
    this.setState({
      renameSet: undefined
    });
  }
  handleRestoreFullStateChange(value) {
    this.setState({
      restoreFullState: value === 'true'
    });
  }
  getNameError(nameInputValue) {
    var _nameInputValue$trim;
    var _this$state2 = this.state,
      renameSet = _this$state2.renameSet,
      modifiedFilterSets = _this$state2.modifiedFilterSets;
    var trimmedName = (_nameInputValue$trim = nameInputValue === null || nameInputValue === void 0 ? void 0 : nameInputValue.trim()) !== null && _nameInputValue$trim !== void 0 ? _nameInputValue$trim : '';
    if (trimmedName.length === 0) {
      log.debug('Name cannot be empty', trimmedName);
      return 'Name cannot be empty';
    }
    if (renameSet !== undefined && modifiedFilterSets.some(_ref3 => {
      var title = _ref3.title,
        id = _ref3.id;
      return title === trimmedName && id !== renameSet.id;
    })) {
      log.debug('Set with this name already exists', trimmedName);
      return 'Set with this name already exists';
    }
    return undefined;
  }
  handleRenameConfirm() {
    var _nameInputValue$trim2;
    var _this$state3 = this.state,
      nameInputValue = _this$state3.nameInputValue,
      renameSet = _this$state3.renameSet,
      modifiedFilterSets = _this$state3.modifiedFilterSets,
      restoreFullState = _this$state3.restoreFullState;
    if (renameSet === undefined) {
      log.error('Renamed set undefined.');
      return;
    }
    var nameInputError = this.getNameError(nameInputValue);
    log.debug('handleRenameConfirm', nameInputValue, nameInputError);
    if (nameInputError !== undefined) {
      this.setState({
        nameInputError
      });
      return;
    }
    var trimmedName = (_nameInputValue$trim2 = nameInputValue === null || nameInputValue === void 0 ? void 0 : nameInputValue.trim()) !== null && _nameInputValue$trim2 !== void 0 ? _nameInputValue$trim2 : '';
    var namedFilterSet = _objectSpread(_objectSpread({}, renameSet), {}, {
      title: trimmedName,
      restoreFullState
    });
    var selectedIndex = modifiedFilterSets.findIndex(_ref4 => {
      var id = _ref4.id;
      return id === renameSet.id;
    });
    var updatedModifiedFilterSets = [...modifiedFilterSets];
    if (selectedIndex >= 0) {
      updatedModifiedFilterSets[selectedIndex] = namedFilterSet;
      log.debug('Renamed existing set', updatedModifiedFilterSets);
    } else {
      updatedModifiedFilterSets.push(namedFilterSet);
      log.debug('Added new set to modified sets', updatedModifiedFilterSets);
    }
    this.setState({
      editId: namedFilterSet.id,
      modifiedFilterSets: updatedModifiedFilterSets,
      renameSet: undefined
    });
  }
  handleSetDelete() {
    this.setState(state => {
      var editId = state.editId,
        prevFilterSets = state.modifiedFilterSets;
      var selectedIndex = prevFilterSets.findIndex(_ref5 => {
        var id = _ref5.id;
        return id === editId;
      });
      if (selectedIndex < 0) {
        log.error('Unable to find selected filterSet index', prevFilterSets, editId);
        return null;
      }
      var modifiedFilterSets = prevFilterSets.filter(_ref6 => {
        var id = _ref6.id;
        return id !== editId;
      });
      var newSelectedIndex = Math.max(0, Math.min(modifiedFilterSets.length - 1, selectedIndex - 1));
      var newSelectedId = modifiedFilterSets.length > 0 ? modifiedFilterSets[newSelectedIndex].id : undefined;
      log.debug('Deleted selected set', editId, prevFilterSets, modifiedFilterSets);
      log.debug('New selection', newSelectedIndex, newSelectedId);
      return {
        modifiedFilterSets,
        editId: newSelectedId
      };
    });
  }
  handleSetUpdate() {
    var getFilterState = this.props.getFilterState;
    FilterSetManager.animateScreenFlash();
    var panels = getFilterState();
    this.setState(_ref7 => {
      var prevFilterSets = _ref7.modifiedFilterSets,
        editId = _ref7.editId;
      if (editId === undefined) {
        log.error('Filter for update not selected.');
        return null;
      }
      var modifiedFilterSets = [...prevFilterSets];
      var selectedSetIndex = modifiedFilterSets.findIndex(_ref8 => {
        var id = _ref8.id;
        return id === editId;
      });
      if (selectedSetIndex < 0) {
        log.error('Selected set for update not found.');
        return null;
      }
      // Clone selected set to avoid mutation of the props
      modifiedFilterSets[selectedSetIndex] = _objectSpread(_objectSpread({}, modifiedFilterSets[selectedSetIndex]), {}, {
        panels
      });
      log.debug('Update set', modifiedFilterSets, panels);
      return {
        modifiedFilterSets
      };
    });
  }
  handleSetEdit() {
    this.setState(_ref9 => {
      var editId = _ref9.editId,
        modifiedFilterSets = _ref9.modifiedFilterSets;
      var selectedSet = modifiedFilterSets.find(_ref0 => {
        var id = _ref0.id;
        return id === editId;
      });
      if (selectedSet === undefined) {
        log.error('Could not find selected set', editId, modifiedFilterSets);
        return null;
      }
      var title = selectedSet.title,
        _selectedSet$restoreF = selectedSet.restoreFullState,
        restoreFullState = _selectedSet$restoreF === void 0 ? false : _selectedSet$restoreF;
      return {
        nameInputValue: title,
        nameInputError: undefined,
        renameSet: selectedSet,
        restoreFullState
      };
    });
  }
  handleSettingsClick(event) {
    event.stopPropagation();
    var _this$props7 = this.props,
      onChange = _this$props7.onChange,
      selectedId = _this$props7.selectedId;
    onChange({
      isValueShown: false,
      selectedId
    });
  }
  handleBackgroundClick(event) {
    log.debug('handleBackgroundClick');
    // allow clicking anywhere in the background to select and focus the input
    if (event.target !== this.dropdownRef.current) {
      this.focusInput();
    }
  }
  handleNameInputChange(event) {
    var nameInputValue = event.target.value;
    var nameInputError = this.getNameError(nameInputValue);
    this.setState({
      nameInputValue,
      nameInputError
    });
  }
  handleNameInputKeyPress(event) {
    var key = event.key;
    if (key === 'Enter') {
      event.preventDefault();
      this.handleRenameConfirm();
    }
  }
  isNameInputScreen() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state;
    var renameSet = state.renameSet;
    return renameSet !== undefined;
  }
  applyFilterSet(selectedId) {
    var _this$props8 = this.props,
      onApply = _this$props8.onApply,
      filterSets = _this$props8.filterSets;
    if (selectedId === undefined) {
      log.debug('No filter selected');
      return;
    }
    var filterSet = filterSets.find(_ref1 => {
      var id = _ref1.id;
      return id === selectedId;
    });
    if (filterSet === undefined) {
      log.debug('Selected id not found in filterSets', selectedId, filterSets);
      return;
    }
    log.debug('Apply filterSet', filterSet);
    onApply(filterSet);
  }
  focusInput() {
    var _this$dropdownRef$cur;
    (_this$dropdownRef$cur = this.dropdownRef.current) === null || _this$dropdownRef$cur === void 0 || _this$dropdownRef$cur.focus();
  }
  focusRenameInput() {
    var _this$renameInputRef$;
    (_this$renameInputRef$ = this.renameInputRef.current) === null || _this$renameInputRef$ === void 0 || _this$renameInputRef$.focus();
  }
  render() {
    var _this$state4 = this.state,
      nameInputValue = _this$state4.nameInputValue,
      nameInputError = _this$state4.nameInputError,
      editId = _this$state4.editId,
      renameSet = _this$state4.renameSet,
      modifiedFilterSets = _this$state4.modifiedFilterSets,
      restoreFullState = _this$state4.restoreFullState;
    var _this$props9 = this.props,
      isValueShown = _this$props9.isValueShown,
      filterSets = _this$props9.filterSets,
      selectedId = _this$props9.selectedId;
    var isNameInputScreen = this.isNameInputScreen();
    var isRenamingExistingSet = this.isRenamingExistingSet(modifiedFilterSets, renameSet);
    var isEmptyEditList = modifiedFilterSets.length === 0;
    var isInitialScreen = !isNameInputScreen && isEmptyEditList && filterSets.length === 0;
    var isEditListScreen = !isNameInputScreen && !isInitialScreen;
    var captureSetIcon = /*#__PURE__*/_jsxs("div", {
      className: "fa-layers mr-3",
      children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: vsCircleLargeFilled,
        mask: vsDeviceCamera,
        transform: "shrink-1 down-5 right-7"
      }), /*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: dhNewCircleLargeFilled,
        className: "text-primary",
        transform: "shrink-6 down-5 right-7"
      })]
    });
    var updateSetIcon = /*#__PURE__*/_jsxs("div", {
      className: "fa-layers",
      children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: vsCircleLargeFilled,
        mask: vsDeviceCamera,
        transform: "shrink-1 down-5 right-7"
      }), /*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: vsArrowSmallUp,
        transform: "shrink-1 down-5 right-7"
      })]
    });
    return /*#__PURE__*/_jsx("div", {
      className: "filter-set-manager fill-parent-absolute",
      children: /*#__PURE__*/_jsxs(CardFlip, {
        className: "w-100 h-100",
        isFlipped: isValueShown,
        children: [/*#__PURE__*/_jsx("div", {
          className: "filter-set-manager-settings-card fill-parent-absolute",
          children: /*#__PURE__*/_jsxs("div", {
            className: "filter-set-manager-card-content",
            children: [isInitialScreen && /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx(Button, {
                kind: "ghost",
                className: "btn btn-link no-underline",
                onClick: this.handleCaptureNewSet,
                icon: captureSetIcon,
                children: "Capture filter set"
              }), /*#__PURE__*/_jsx("div", {
                className: "py-3  text-muted small",
                children: "Takes a snapshot of the currently applied filters on all panels, allowing you to restore saved filter sets later."
              })]
            }), isNameInputScreen && /*#__PURE__*/_jsxs("div", {
              className: "d-flex flex-column justify-content-center",
              "data-testid": "edit-filter-set-container",
              children: [/*#__PURE__*/_jsxs("div", {
                className: "form-group",
                children: [/*#__PURE__*/_jsx("label", {
                  children: isRenamingExistingSet ? 'Edit set' : 'Name captured set'
                }), /*#__PURE__*/_jsxs("div", {
                  className: "name-input-container",
                  children: [/*#__PURE__*/_jsx("input", {
                    type: "text",
                    className: "input-set-name form-control",
                    placeholder: NAME_INPUT_PLACEHOLDER,
                    value: nameInputValue,
                    ref: this.renameInputRef,
                    onChange: this.handleNameInputChange,
                    onKeyPress: this.handleNameInputKeyPress,
                    spellCheck: "false"
                  }), /*#__PURE__*/_jsx(Button, {
                    "data-testid": "rename-confirm-button",
                    kind: "ghost",
                    className: "btn btn-link no-underline pt-2 pb-2",
                    onClick: this.handleRenameConfirm,
                    tooltip: "Save",
                    "test-id": "button-save",
                    icon: vsSave
                  }), /*#__PURE__*/_jsx(Button, {
                    "data-testid": "rename-cancel-button",
                    kind: "ghost",
                    className: "btn btn-link no-underline pt-2 pb-2",
                    onClick: this.handleRenameCancel,
                    tooltip: "Cancel",
                    icon: vsCircleSlash
                  })]
                }), nameInputError !== undefined && /*#__PURE__*/_jsx("div", {
                  className: "error-message",
                  children: nameInputError
                })]
              }), /*#__PURE__*/_jsx("div", {
                className: "form-group",
                children: /*#__PURE__*/_jsxs(RadioGroup, {
                  "aria-label": "Restoration options",
                  onChange: this.handleRestoreFullStateChange,
                  value: "".concat(restoreFullState),
                  children: [/*#__PURE__*/_jsx(Radio, {
                    value: "false",
                    children: "Restore only filters"
                  }), /*#__PURE__*/_jsx(Radio, {
                    value: "true",
                    children: "Restore full table state"
                  })]
                })
              })]
            }), isEditListScreen && /*#__PURE__*/_jsxs("div", {
              className: "filter-set-manager-settings-grid-1",
              children: [/*#__PURE__*/_jsxs("div", {
                className: "form-group",
                children: [/*#__PURE__*/_jsx("label", {
                  children: "Edit filter sets"
                }), /*#__PURE__*/_jsxs("div", {
                  className: "filter-select-container",
                  children: [/*#__PURE__*/_jsxs(Select, {
                    "data-testid": "settings-card-filter-select",
                    ref: this.editDropdownRef,
                    value: editId !== null && editId !== void 0 ? editId : '-1',
                    className: "custom-select filter-value-select",
                    onChange: this.handleEditDropdownChange,
                    disabled: isEmptyEditList,
                    children: [isEmptyEditList && /*#__PURE__*/_jsx("option", {
                      value: "-1",
                      disabled: true,
                      children: EMPTY_LIST_PLACEHOLDER
                    }), modifiedFilterSets.map(_ref10 => {
                      var id = _ref10.id,
                        title = _ref10.title;
                      return /*#__PURE__*/_jsx("option", {
                        value: id,
                        children: title
                      }, id);
                    })]
                  }), /*#__PURE__*/_jsx(Button, {
                    kind: "ghost",
                    onClick: this.handleSetUpdate,
                    disabled: isEmptyEditList,
                    icon: updateSetIcon,
                    tooltip: "Update"
                  }), /*#__PURE__*/_jsx(Button, {
                    kind: "ghost",
                    onClick: this.handleSetEdit,
                    disabled: isEmptyEditList,
                    icon: vsEdit,
                    tooltip: "Edit"
                  }), /*#__PURE__*/_jsx(Button, {
                    kind: "ghost",
                    onClick: this.handleSetDelete,
                    disabled: isEmptyEditList,
                    icon: vsTrash,
                    tooltip: "Delete"
                  })]
                })]
              }), /*#__PURE__*/_jsx("div", {
                children: /*#__PURE__*/_jsx(Button, {
                  kind: "ghost",
                  className: "btn btn-link no-underline",
                  onClick: this.handleCaptureNewSet,
                  icon: captureSetIcon,
                  children: "Capture new filter set"
                })
              }), /*#__PURE__*/_jsxs("div", {
                className: "py-3 text-right",
                children: [/*#__PURE__*/_jsx(Button, {
                  kind: "secondary",
                  onClick: this.handleSettingsCancel,
                  children: "Cancel"
                }), "\xA0", /*#__PURE__*/_jsx(Button, {
                  kind: "primary",
                  onClick: this.handleSettingsSave,
                  children: "Save"
                })]
              })]
            })]
          })
        }, "front"), /*#__PURE__*/_jsxs("div", {
          className: "filter-set-manager-value-card fill-parent-absolute",
          onClick: this.handleBackgroundClick,
          children: [/*#__PURE__*/_jsx("div", {
            className: "filter-set-manager-column",
            children: /*#__PURE__*/_jsx("div", {
              className: "filter-set-manager-column-title",
              children: "Filter sets"
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "filter-set-manager-card-content",
            children: /*#__PURE__*/_jsx("div", {
              className: "filter-set-manager-value-input",
              children: /*#__PURE__*/_jsxs("div", {
                className: "filter-select-container",
                children: [/*#__PURE__*/_jsxs(Select, {
                  "data-testid": "value-card-filter-select",
                  ref: this.dropdownRef,
                  value: selectedId !== null && selectedId !== void 0 ? selectedId : '-1',
                  className: "custom-select filter-value-select",
                  onChange: this.handleFilterChange,
                  children: [filterSets.length === 0 && /*#__PURE__*/_jsx("option", {
                    value: "-1",
                    disabled: true,
                    children: EMPTY_LIST_PLACEHOLDER
                  }), filterSets.map(_ref11 => {
                    var id = _ref11.id,
                      title = _ref11.title;
                    return /*#__PURE__*/_jsx("option", {
                      value: id,
                      children: title
                    }, id);
                  })]
                }), /*#__PURE__*/_jsx(Button, {
                  "data-testid": "filter-apply-button",
                  kind: "ghost",
                  onClick: this.handleFilterApply,
                  icon: dhRefresh,
                  tooltip: "Apply Filter Set"
                })]
              })
            })
          }), /*#__PURE__*/_jsx("div", {
            className: "filter-set-manager-menu",
            children: /*#__PURE__*/_jsx(Button, {
              kind: "ghost",
              className: "btn btn-link btn-link-icon m-2 px-2",
              onClick: this.handleSettingsClick,
              tooltip: "Settings",
              icon: /*#__PURE__*/_jsx(FontAwesomeIcon, {
                icon: vsGear,
                transform: "grow-4"
              })
            })
          })]
        }, "back")]
      })
    });
  }
}
export default FilterSetManager;
//# sourceMappingURL=FilterSetManager.js.map